import React, { useState } from 'react';
import { Button, Stack, IconButton, useMediaQuery } from '@mui/material';
import { Box, styled, useTheme , Container, } from '@mui/system';
import MenuIcon from '@mui/icons-material/Menu';
import Icon from 'app/components/Icon';
import { useSelector } from 'react-redux';
import { NavLink, useNavigate, useLocation } from 'react-router-dom';

import UserMenu from 'app/components/UserMenu';
import Logo from 'app/components/Logo';

import { themeShadows } from 'app/components/Theme/themeColors';
import { topBarHeight } from 'app/utils/constant';
import { Span } from 'app/components/Typography';
//import { setMode } from 'app/redux/actions/SettingActions';

import menu from '../../../../config/menu';

const MenuButton = styled(IconButton)(({ theme }) => ({
  color: "#FFF", marginRight: 5,
  [theme.breakpoints.up('sm')]: {
    display:"none"
  },

}));

const TopbarRoot = styled('div')(({ theme }) => ({
  top: 0,
  zIndex: 96,
  transition: 'all 0.3s ease',
  boxShadow: themeShadows[8],
  height: topBarHeight,
  position:'fixed',
  width:"100%",
}));

const TopbarContainer = styled(Box)(({ theme }) => ({
  padding: '8px',
  paddingLeft: 16,
  paddingRight: 16,
  height: '100%',
  display: 'flex',
  alignItems: 'center',
  '& .MuiContainer-root > .MuiBox-root' : { justifyContent: 'space-between' },
  background: theme.palette.secondary.main,
  //background:"transparent",
  [theme.breakpoints.down('sm')]: {
    paddingLeft: 14,
    paddingRight: 12,
    '& .MuiContainer-root > .MuiBox-root' : {justifyContent: 'flex-start' },
  },
}));

const Menu = styled(Box)(({ theme, opened }) => ({
  display: 'flex', gap: 10,
  '& a': { 
    textDecoration:"none",
    color: "#FFF",  padding:"6px 15px 6px 13px",  borderRadius:4, fontWeight:"bold", alignItems:'center' ,display: 'inline-flex',
    ":hover":{ background:"#229fe1" },
    "& span.MuiBox-root": { textTransform:"uppercase", marginLeft:4 },
  },
  [theme.breakpoints.down('md')]: {
    gap: 5,
    '& a': {
      padding:"6px 8px 6px 8px",
      fontSize:13,
    }
  },
  [theme.breakpoints.down('sm')]: {
    display: opened ? "flex" : "none",
    position: "absolute",
    background: 'rgba(0,0,0,0.95)',
    left: 0,
    top: topBarHeight,
    width: '100%',
    bottom:0,
    padding: "10px 9px",
    flexDirection: 'column',
    height:"100vh",
    '& a': {
      '& .material-icons': { fontSize:20 }
    },
   //  transform: opened ? 'translateX(0%)' : 'translateX(100%)',
    //transition: 'transform 0.3s ease-in-out'

    /*
    gap: 2,
    '& a': {
      padding:"6px 8px 6px 8px",
      fontSize:13,
      
    },
    */
  }

}));

const ButtonContainer = styled(Stack)(({theme})=>({
  [theme.breakpoints.up('sm')]: { minWidth:"150px", justifyContent:"flex-end" },
  [theme.breakpoints.down('sm')]: { position:"absolute", right:16 }
}));

const BootstrapButton = styled(Button)(({ theme, background = ''})=>({
  boxShadow: 'none',
  textTransform: 'none',
  fontSize: 14,
  padding: '6px 10px',
  border: '1px solid',
  lineHeight: 1.6,
  alignItems:"center",
  minWidth:40,
  marginLeft:"10px !important",
  background: background !==  '' ? background : theme.palette.secondary2.main,
  borderColor: theme.palette.secondary2.main,
  '&:hover': {
    backgroundColor: theme.palette.secondary.main,
    borderColor: 'transparent',// theme.palette.secondary2.main,
    boxShadow: 'none',
  },
  '&:active': {
    boxShadow: 'none',
  },
  '&:focus': {
    boxShadow: 'none',
  },
  '& .btnText': {
    marginLeft:'5px',
    [theme.breakpoints.down('sm')]: { display: 'none' }
  },
  [theme.breakpoints.down('sm')]: { padding:"8px 8px" },
}));

const Layout0Topbar = () => {
  const theme = useTheme();
  const auth = useSelector(store=>store.auth);
 // const settings = useSelector(store=>store.settings);
  //const isMdScreen = useMediaQuery(theme.breakpoints.down('md'));
  const isSmScreen = useMediaQuery(theme.breakpoints.down('sm'));
  
 // const dispatch = useDispatch();
  const navigate = useNavigate();
  const [open,setOpen] = useState(false);
  const { pathname } = useLocation();
  /*
  const handleSidebarToggle = () => {
    let { layout1Settings } = settings;
    let mode;
    if (isMdScreen) {
      mode = layout1Settings.leftSidebar.mode === 'close' ? 'mobile' : 'close';
    } else {
      mode = layout1Settings.leftSidebar.mode === 'full' ? 'compact' : 'full';
    }
    dispatch(setMode(mode));
  };
  */

  return (
    <TopbarRoot>
      <TopbarContainer>
        <Container maxWidth="lg" className="header-container">

          <Box display="flex" alignItems="center">
            
            {(menu?.top || (isSmScreen && menu?.footer)) && <MenuButton size="large" edge="start" color="inherit" aria-label="menu" onClick={()=>setOpen(!open)}>
              {open ? <Icon size={20} style={{ width:"24px" }}>times</Icon> : <MenuIcon />}
            </MenuButton>}

            <Logo onClick={()=>setOpen(false)}/>
            {(menu?.top || (isSmScreen && menu?.footer)) && <Menu opened={open ? 1 : 0}>
                {menu.top.map((mitem,mi)=>{
                    return <NavLink key={`menu_top_${mi}`} onClick={()=>setOpen(false)} to={mitem?.path}>
                    {mitem?.icon && <Icon wide={true}>{mitem?.icon}</Icon>}
                    <Span>{mitem.title}</Span>
                  </NavLink>;
                })}
                {(isSmScreen && menu?.footer) && menu.footer.map((mitem,mi)=>{
                    return <NavLink key={`menu_top_${mi}`} onClick={()=>setOpen(false)} to={mitem?.path}>
                    {mitem?.icon && <Icon wide={true}>{mitem?.icon}</Icon>}
                    <Span>{mitem.title}</Span>
                  </NavLink>;
                })}
            </Menu>}

            <ButtonContainer spacing={2} direction="row">
              {auth.isLogged ? <UserMenu source="default"/> :
              <>  
                {!(pathname ===   '/' || pathname ===   '/login') && <BootstrapButton onClick={()=>{ setOpen(false); navigate('/login')}}>
                  <Icon className="icon">lock</Icon>
                  <Span className="btnText">Login</Span>
                </BootstrapButton>}
                {pathname !=='/register' && <BootstrapButton onClick={()=>{ setOpen(false); navigate('/register')}} background={(pathname ===  '/' || pathname ===  '/login' ) ? '' : 'none'}>
                  <Icon className="icon">plus</Icon>
                  <Span className="btnText">Register</Span>
                </BootstrapButton>}
              </>}
            </ButtonContainer>
          
          </Box>
        </Container>
      </TopbarContainer>
    </TopbarRoot>
  );
};

export default React.memo(Layout0Topbar);